<template>
  <v-container fill-height>
    <v-layout
      align-center
      justify-center
      fill-height
    >
      <v-flex
        shrink
        style="margin-top:-200px"
      >
        <div class=" mb-4">
          <SiLogo size="56" />
        </div>
        <div
          class="display-3 "
          style="line-height:80px"
        >
          Hello, <br>
          Were just upgrading to Super Info 2.0 <br>
          We'll be back in a jiffy.
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>